// extracted by mini-css-extract-plugin
export default {"dashboardWrapper":"dashboard_dashboardWrapper__jOX41","mainContent":"dashboard_mainContent__C6wet"};